import { NewsItem } from "../../components/Freemium/News/News";

export const mockNewsItems: NewsItem[] = [
  {
    id: "1",
    type: "article",
    header: {
      avatarUrl: "https://www.figma.com/api/mcp/asset/183312c5-8bf7-40ea-a3f7-055538010482",
      title: "Trustpilot",
      source: "TECHCRUNCH.COM",
      timeAgo: "8 hours ago"
    },
    tag: {
      label: "Competitor",
      color: "#f6f8fc"
    },
    title:
      "With Nearly 7M Reviews Of 100K Sites, Trustpilot Raises $13M From Index And More To Build Out A Yelp For The World Of E-Commerce",
    content:
      "Trustpilot, the online customer reviews service with nearly 7 million reviews on its platform covering 100,000 merchants to date — and a partner in Google's Adwords business — is today announcing another €10 million ($13 million) in funding. The investment is led by new investor Index Ventures, with participation also from existing backers SEED Capital Denmark and the Scandinavian VC that is also an investor in Spotify.",
    actions: {
      showBookmark: true,
      showSend: true,
      showComment: true,
      showSeeItem: false,
      commentsCount: 6
    }
  },
  {
    id: "2",
    type: "deals",
    header: {
      avatarUrl: "https://www.figma.com/api/mcp/asset/57a2a6ba-b696-4683-9032-d447d84c3aa2",
      title: "Altius Update",
      date: "Aug 23",
      timeAgo: "8 hours ago"
    },
    title: "September deals digest",
    description:
      "Since the last update, 12 new offers have been added to the platform. Explore each offer in more detail and find out which one is right for you.",
    deals: [
      {
        name: "Merida Tools",
        commitment: "$12 000 000",
        roi: "$8 000 000",
        avatarUrl: "https://www.figma.com/api/mcp/asset/ba60ed75-13a2-4be9-8cfe-4c4ca36c0671"
      },
      {
        name: "Tetralist",
        commitment: "$12 000 000",
        roi: "$8 000 000",
        avatarUrl: "https://www.figma.com/api/mcp/asset/6fd59d2c-e743-4a5b-8327-e99be99a2a1b"
      },
      {
        name: "Quantum Ventures",
        commitment: "$15 000 000",
        roi: "$10 000 000",
        avatarUrl: "https://www.figma.com/api/mcp/asset/ba60ed75-13a2-4be9-8cfe-4c4ca36c0671"
      },
      {
        name: "Stellar Capital",
        commitment: "$20 000 000",
        roi: "$14 000 000",
        avatarUrl: "https://www.figma.com/api/mcp/asset/6fd59d2c-e743-4a5b-8327-e99be99a2a1b"
      },
      {
        name: "Apex Investments",
        commitment: "$18 000 000",
        roi: "$12 000 000",
        avatarUrl: "https://www.figma.com/api/mcp/asset/ba60ed75-13a2-4be9-8cfe-4c4ca36c0671"
      },
      {
        name: "Nexus Partners",
        commitment: "$25 000 000",
        roi: "$18 000 000",
        avatarUrl: "https://www.figma.com/api/mcp/asset/6fd59d2c-e743-4a5b-8327-e99be99a2a1b"
      }
    ],
    seeFullListLink: "#",
    actions: {
      showBookmark: false,
      showSend: false,
      showComment: false,
      showSeeItem: false,
      commentsCount: 0
    }
  },
  {
    id: "3",
    type: "article",
    header: {
      avatarUrl: "https://www.figma.com/api/mcp/asset/0fc0c427-741d-4e01-807c-aa761ac088af",
      title: "Altius Academy",
      category: "Investment",
      timeAgo: "8 hours ago"
    },
    title: "Top 10 investment strategies in real estate",
    content:
      "Remember that no strategy guarantees success, and it's crucial to consider your financial goals, risk tolerance, and investment horizon when selecting an approach. Additionally, staying informed about market trends and regularly reviewing your portfolio can be essential for successful investing.",
    imageUrl: "https://www.figma.com/api/mcp/asset/51157c1b-ff47-46c8-a148-7831fc7c26cf",
    actions: {
      showBookmark: true,
      showSend: true,
      showComment: false,
      showSeeItem: true,
      commentsCount: 0
    }
  }
];
